import { AxiosError } from "axios"

import { Botao, Cores, Corpo, Icone, Titulo } from "@componentes-mu/componentes-mu"

import { DefaultApiError } from "../../services/types"
import styles from './styles.module.scss'

type NotFoundProps = {
    error: AxiosError<DefaultApiError> | null
    defaultMessage?: string
    retry?: () => void
}
export const NotFound = ({ error, defaultMessage, retry }: NotFoundProps) => (
    <div>
        {error && (
            <div className={styles.wrapper}>
                <div className={styles.notFoundContainer}>
                    <Icone nome="error" cor={Cores.MensagensDoSistema.VermelhoMU} />
                    <Titulo tipo="cabecalho3" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito>
                        {"Ops, um error aconteceu!"}
                    </Titulo>

                    <Corpo tipo="body1" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito={500} style={{ textAlign: 'center' }}>
                        {error.response?.data.mensagem ?? (error.message !== '' ? error.message : defaultMessage)}
                        ({error.response?.data.codigoErro ?? (error.code !== '' ? error.code : "Extranet Error")})
                    </Corpo>

                    {retry && error.status === 500 && (
                        <Botao tipoComportamento="button" onClick={retry} estilo="error">
                            <Corpo tipo="button1" cor={Cores.CoresIdentidadeMU.brancoMu} negrito={700}>
                                Tente novamente
                            </Corpo>
                        </Botao>
                    )}
                </div>
            </div>
        )}
    </div>
)